import { render, staticRenderFns } from "./StepsFirst.vue?vue&type=template&id=63ae8965&scoped=true"
import script from "./StepsFirst.vue?vue&type=script&lang=js"
export * from "./StepsFirst.vue?vue&type=script&lang=js"
import style0 from "./StepsFirst.vue?vue&type=style&index=0&id=63ae8965&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "63ae8965",
  null
  
)

export default component.exports